import type { GetPublicSettings } from '@virtual-care/client';
import { useData } from '@virtual-care/ui';

export function useSettings() {
  const settings = useData(
    'GET /settings/public',
    {},
    {
      staleTime: Infinity,
    },
  );
  return settings.data;
}

export function useSetting(name: keyof GetPublicSettings) {
  const settings = useSettings();
  return settings ? settings[name] : undefined;
}

export function useSettingValue(name: keyof GetPublicSettings) {
  return useSetting(name)?.value;
}
